import Vue from 'vue'
import Vuex from 'vuex'
import {getProjectStorageSize} from '@/helpers/api/fileManager'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		projectStorageInfo: {
			total_size: 0,
			total_count: 0,
			total_files_size: 0,
			total_files_count: 0,
			total_files_version_size: 0,
			total_files_version_count: 0,
		},
		loadingStorageInfo: false,
	},
	mutations: {
		setLoadingStorageInfo(state, status){
			state.loadingStorageInfo = status
		},
		setProjectStorageInfo(state, info){
			state.projectStorageInfo = info
		},
		resetForProject(state){
			state.projectStorageInfo = {
				total_size: 0,
				total_count: 0,
				total_files_size: 0,
				total_files_count: 0,
				total_files_version_size: 0,
				total_files_version_count: 0,
			}
			state.loadingStorageInfo = false
		},
	},
	actions: {
		async getProjectStorageSize(context, query){
			const request = getProjectRequest(query.project_id)
			context.commit('setLoadingStorageInfo', true)
			const data = { project_id: query.project_id }
			const storageInfo = await getProjectStorageSize(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && storageInfo.code === 200){
				context.commit('setProjectStorageInfo', storageInfo.data)
			}
			if(isCurrentProjectRequest(request.projectId, request.generation)) context.commit('setLoadingStorageInfo', false)
		}
	}
})

export default store